export default {
  calcColor({ image, colorThief }) {
    const [r, g, b] = colorThief.getColor(image)

    // Formula is ITU-R BT.2020 https://en.wikipedia.org/wiki/Rec._2020#RGB_and_luma-chroma_formats (search for "weighting coefficients")
    const luminance = 0.2627 * r + 0.6780 * g + 0.0593 * b

    const isLight = luminance > 128
    return {
      isLight,
      color: `rgb(${r}, ${g}, ${b})`,
      rawColor: {
        r, g, b,
      },
    }
  },
}
